module.exports = __webpack_public_path__ + "static/media/bitlyImg.7c0b9b1d.gif";